import React, { useState } from 'react'
import { setStream } from 'actions/stream'
import {
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Slide
} from '@material-ui/core'
import useStyles from './styles'
import { useDispatch, useSelector } from 'react-redux'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const SetNameDialog = props => {
  const classes = useStyles()
  const [streamName, setStreamName] = useState('')

  const open = useSelector(state => state.stream.nameDialogOpen)

  const dispatch = useDispatch()

  const handleClose = confirm => {
    dispatch(setStream({ nameDialogOpen: false, name: streamName }))
  }

  return (
    <Dialog
      open={open}
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="responsive-dialog-title"
      TransitionComponent={Transition}
      keepMounted
      classes={{
        paper: classes.dialogPaper
      }}
    >
      <DialogContent>
        <Typography style={{ fontSize: 18 }}>
          What do you want to call your stream?
        </Typography>
        <TextField
          value={streamName}
          onChange={e => setStreamName(e.target.value)}
          label="Stream Name"
          fullWidth
          onKeyPress={e => {
            if (e.key === 'Enter') {
              handleClose(true)
            }
          }}
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        {/* <Button
          style={{ marginRight: 8 }}
          size="small"
          variant="contained"
          onClick={() => window.location.reload()}
        >
          Close
        </Button> */}
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => handleClose(true)}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SetNameDialog



// WEBPACK FOOTER //
// ./src/pages/Stream/setNameDialog.jsx